// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyCodeController from "./copy_code_controller"
application.register("copy-code", CopyCodeController)

import CoverUploadController from "./cover_upload_controller"
application.register("cover-upload", CoverUploadController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import HeaderDropdownController from "./header_dropdown_controller"
application.register("header-dropdown", HeaderDropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IconAppreciationController from "./icon_appreciation_controller"
application.register("icon-appreciation", IconAppreciationController)

import IconBookmarkController from "./icon_bookmark_controller"
application.register("icon-bookmark", IconBookmarkController)

import IconClockController from "./icon_clock_controller"
application.register("icon-clock", IconClockController)

import IconCommentsController from "./icon_comments_controller"
application.register("icon-comments", IconCommentsController)

import ReadingModeController from "./reading_mode_controller"
application.register("reading-mode", ReadingModeController)

import ReadingListFilterController from "./reading_list_filter_controller"
application.register("reading-list-filter", ReadingListFilterController)

import ReportModalController from "./report_modal_controller"
application.register("report-modal", ReportModalController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SplashController from "./splash_controller"
application.register("splash", SplashController)

import StoryReadTrackerController from "./story_read_tracker_controller"
application.register("story-read-tracker", StoryReadTrackerController)

import StoryRenderController from "./story_render_controller"
application.register("story-render", StoryRenderController)

import TextSelectionController from "./text_selection_controller"
application.register("text-selection", TextSelectionController)

import TitleCounterController from "./title_counter_controller"
application.register("title-counter", TitleCounterController)

import LikesListController from "./likes_list_controller"
application.register("likes-list", LikesListController)

import TagPickerController from "./tag_picker_controller"
application.register("tag-picker", TagPickerController)

import TagCarouselController from "./tag_carousel_controller"
application.register("tag-carousel", TagCarouselController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import InsightsController from "./insights_controller"
application.register("insights", InsightsController)

import DiscussionVoteController from "./discussion_vote_controller"
application.register("discussion-vote", DiscussionVoteController)

import LandingAnimateController from "./landing_animate_controller"
application.register("landing-animate", LandingAnimateController)

import LandingRevealController from "./landing_reveal_controller"
application.register("landing-reveal", LandingRevealController)

import LandingEditorController from "./landing_editor_controller"
application.register("landing-editor", LandingEditorController)

import LandingPublishController from "./landing_publish_controller"
application.register("landing-publish", LandingPublishController)

import LandingReaderController from "./landing_reader_controller"
application.register("landing-reader", LandingReaderController)

import LandingMetricsController from "./landing_metrics_controller"
application.register("landing-metrics", LandingMetricsController)

import LandingDiscussController from "./landing_discuss_controller"
application.register("landing-discuss", LandingDiscussController)

import LandingSearchController from "./landing_search_controller"
application.register("landing-search", LandingSearchController)

import LandingNotifyController from "./landing_notify_controller"
application.register("landing-notify", LandingNotifyController)

import LandingFocusController from "./landing_focus_controller"
application.register("landing-focus", LandingFocusController)

import StoryTocController from "./story_toc_controller"
application.register("story-toc", StoryTocController)

import StoryMarginController from "./story_margin_controller"
application.register("story-margin", StoryMarginController)

import DockMenuController from "./dock_menu_controller"
application.register("dock-menu", DockMenuController)

import SiteHeaderController from "./site_header_controller"
application.register("site-header", SiteHeaderController)

import TopicFilterController from "./topic_filter_controller"
application.register("topic-filter", TopicFilterController)
